<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<!-- <mat-card-title>入金消込</mat-card-title> -->
<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center ">
    <mat-radio-group name="registType" color="warn" (change)="onChangeRadio($event.value)"
        class="search-condition-radio-frame" [(ngModel)]="registType"
        style="position: relative;border: solid 1px rgba(117, 62, 62, 0.12); border-radius: 5px; padding-right: 1em; margin-top: 15px;">
        <mat-label
            style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
            登録種別</mat-label>
        <mat-radio-button class="radio-button-margin" [value]="1"
            style="margin-bottom: 10px!important; margin-top: 10px;" checked>入金消込</mat-radio-button>
    </mat-radio-group>
</div>

<div class="furikae" *ngIf="registType=='1'">
    <app-sgke030d-view [kinkoMno]="searchResultList[0]?.kinkoMno" [kinkoRrkno]="searchResultList[0]?.kinkoRrkno"
        [receiveMoneyNo]="searchResultList[0]?.receiveMoneyNo" [recptFixNo]="searchResultList[0]?.paymentContractNo"
        [remny]="searchResultList[0]?.remny" [kinkoUpdateSrno]="searchResultList[0]?.kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="searchResultList[0]?.kinkoexUpdatesequencenumber"
        (normalMessageEmit)="showNormalMsg($event)" (warningMessageEmit)="showWarningMsg($event)"
        (errorMessageEmit)="showErrorMsg($event)" (clearMessageEmit)="clearErrorMsg()" (searchEmit)="search($event)"
        (responseMsgEmit)="showNormalMsg($event)" (msgEmit)="showMsg($event)"></app-sgke030d-view>
</div>